import { verifyRequiredUserData } from '../betaFeatures/verifyRequiredBetaFeatures';

export function verifyRequiredFeatures(requiredFeaturesArr) {
  return verifyRequiredUserData(requiredFeaturesArr, 'features');
}
